import { useSelector } from "react-redux";
import "./AppEmployeeRecordsFlatten.css";
import { selectUser } from "../../../redux/features/appData";
import { useEffect, useState, useRef } from "react";
import { apiGetFlattenedEmployeeRecordsFromWorkspace } from "../../../services/EmployeeRecordService";

export const AppEmployeeRecordsFlatten = () => {

    const storeUser = useSelector(selectUser);

    const [flattened, setFlattened] = useState<string | null>(null);
    const hasOpenedWindow = useRef(false);

    useEffect(() => {
        if (!flattened && !hasOpenedWindow.current) {
            hasOpenedWindow.current = true;
            (async () => {
                const flat = await apiGetFlattenedEmployeeRecordsFromWorkspace(storeUser?.currentWorkspaceId || "");

                console.log("[AppEmployeeRecordsFlatten] flat: ", flat);

                if (!flat) {
                    console.error("Failed to get flattened data");
                    return;
                }

                setFlattened(flat);

                const newWindow = window.open("", "_blank"); // Open a new blank window

                if (newWindow) {
                    newWindow.document.write(`
                        <html>
                        <head>
                            <title>JSON Data</title>
                            <style>
                            body { font-family: monospace; white-space: pre; padding: 20px; background-color: #f4f4f4; }
                            </style>
                        </head>
                        <body>${flat.replace(/\n/g, "<br>").replace(/ /g, "&nbsp;")}</body>
                        </html>
                    `);
                    newWindow.document.close();
                }

            })();
        }
    }, [flattened, storeUser?.currentWorkspaceId]);
    
    return (
        <div className="app-employee-records-flatten">
            <div className="app-employee-records-flatten-section">
                Flatten
            </div>
        </div>
    )
}